export default {
  // App
  "appTitle": "多功能计时器和秒表",
  "siteIntro": "创建和管理带有多种视觉效果和通知的自定义计时器和秒表",
  
  // General
  "cancel": "取消",
  "save": "保存",
  "start": "开始",
  "pause": "暂停",
  "stop": "停止",
  "reset": "重置",
  "add": "添加",
  "edit": "编辑",
  "delete": "删除",
  "confirm": "确认",
  "close": "关闭",
  "back": "返回",
  "submit": "提交",
  "timer": "计时器",
  "optional": "可选",
  "clickAgainToDelete": "再次点击删除",
  "fullscreen": "全屏",
  "exitFullscreen": "退出全屏",
  
  // Timer modes
  "countdown": "倒计时",
  "stopwatch": "秒表",
  
  // TimersContainer
  "myTimers": "我的计时器",
  "addTimer": "添加计时器",
  "noTimers": "还没有计时器",
  "createFirstTimer": "创建您的第一个计时器",
  
  // TimerForm
  "createTimer": "创建计时器",
  "editTimer": "编辑计时器",
  "timerName": "计时器名称",
  "timerNamePlaceholder": "输入计时器名称",
  "timerMode": "计时器模式",
  "duration": "持续时间",
  "hours": "小时",
  "minutes": "分钟",
  "seconds": "秒",
  "showMilliseconds": "显示毫秒",
  
  // Settings
  "settings": "设置",
  "darkMode": "深色模式",
  "language": "语言",
  "notificationSound": "通知声音",
  "enableNotifications": "启用通知",
  "english": "英语",
  "chinese": "中文",
  "spanish": "西班牙语",
  "french": "法语",
  "japanese": "日语",
  
  // Notification sounds
  "default": "默认",
  "bell": "铃声",
  "digital": "数字音",
  "chime": "风铃声",
  "none": "无",
  
  // Messages
  "timerComplete": "计时器完成！",
  
  // Effects
  "effect": "效果",
  "effectSettings": "效果设置",
  "effectType": "效果类型",
  "opacity": "不透明度",
  "speed": "速度",
  "primaryColor": "主要颜色",
  "secondaryColor": "次要颜色",
  "circle": "圆圈",
  "wave": "波浪",
  "pulse": "脉冲",
  "particles": "粒子",
  "gradient": "渐变",
  "ripple": "水波",
  
  // About page
  "about": "关于",
  "aboutTitle": "关于此应用",
  "aboutIntroTitle": "欢迎使用多功能计时器和秒表",
  "aboutIntroText": "这个网页应用允许您创建和管理多个可自定义的计时器和秒表。无论您需要跟踪锻炼时间、烹饪时间还是工作间隔，这个工具都提供了灵活且易用的解决方案。",
  
  "aboutFeaturesTitle": "主要功能",
  "aboutFeatureTimersTitle": "计时器和秒表",
  "aboutFeatureTimersText": "您可以创建倒计时计时器和秒表两种类型。倒计时计时器可以设置小时、分钟和秒，而秒表则从零开始测量时间。",
  
  "aboutFeatureNotificationsTitle": "通知",
  "aboutFeatureNotificationsText": "计时器完成时接收视觉和声音提醒。您可以从多种通知声音中选择，或选择静音操作。",
  
  "aboutFeatureEffectsTitle": "视觉效果",
  "aboutFeatureEffectsText": "使用各种视觉效果自定义您的计时器，包括圆圈、波浪、脉冲、粒子和渐变等。您可以根据偏好调整不透明度、速度和颜色。",
  
  "aboutFeatureShortcutsTitle": "键盘快捷键",
  "aboutFeatureShortcutsText": "使用开始、暂停、停止和重置功能的键盘快捷键来高效控制您的计时器。",
  
  "aboutFeatureLanguagesTitle": "多语言支持",
  "aboutFeatureLanguagesText": "使用您偏好的语言体验应用。目前支持英语、中文、西班牙语、法语和日语。",
  
  "aboutFeatureDarkModeTitle": "深色模式",
  "aboutFeatureDarkModeText": "在明亮和黑暗主题之间切换，减少眼睛疲劳并延长OLED设备的电池寿命。",
  
  "aboutHowToUseTitle": "使用方法",
  "aboutHowToCreateTitle": "创建计时器",
  "aboutHowToCreateText": "点击\"添加计时器\"按钮，输入名称，选择计时器模式（倒计时或秒表），设置时间（如果是倒计时），并自定义视觉效果。完成后，点击\"保存\"。",
  
  "aboutHowToControlTitle": "控制计时器",
  "aboutHowToControlText": "使用控制按钮开始、暂停、停止和重置您的计时器。您还可以切换到全屏模式以获得更好的可视性。",
  
  "aboutHowToCustomizeTitle": "自定义效果",
  "aboutHowToCustomizeText": "创建或编辑计时器时，选择效果类型并使用不透明度、速度和颜色控件调整外观。",
  
  "aboutHowToManageTitle": "管理计时器",
  "aboutHowToManageText": "点击编辑图标修改现有计时器。双击删除图标删除计时器。所有计时器都会自动保存，并在您返回时可用。",
  
  "aboutProjectTitle": "关于项目",
  "aboutProjectText": "这个项目是使用React、TypeScript以及各种用于动画和状态管理的库开发的现代网页应用。",
  
  "aboutVersionInfo": "版本 1.0.0"
}; 